import React, { useState } from 'react';
import './css/AltcorAI.css';
import ApplicationPopup from '../Popup/ApplicationPopup';

const AltcorAI = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <section className="altcor-ai-section" id="altcor-ai">
      <div className="container altcor-ai-container">
        <div className="altcor-ai-content">
          <div className="altcor-ai-text">
            <span className="altcor-ai-badge">AI</span>
            <h2 className="altcor-ai-title">
              ALTCOR AI — распознавание и классификация персональных данных в документах
            </h2>
            <p className="altcor-ai-description">
              Наша система искусственного интеллекта обнаруживает и классифицирует персональные данные в документах с беспрецедентной точностью. 
              Мы первые в России, кто разработал программу с такими возможностями и точностью анализа.
            </p>
            
            <div className="altcor-ai-features-container">
              <div>
                <div className="altcor-ai-features">
                  <div className="altcor-ai-feature">
                    <div className="altcor-ai-feature-icon">
                      <i className="fas fa-bolt"></i>
                    </div>
                    <span className="altcor-ai-feature-text">Высокая точность распознавания - более 98%</span>
                  </div>
                  <div className="altcor-ai-feature">
                    <div className="altcor-ai-feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 297 297"><path d="m102.651 253.945-.068-.139 16.5-12.92-30.623-55.712-.086-.157C51.307 199.906 26.287 233.051 26.287 297h97.472l-21.176-43 .068-.055zM178.157 240.752l16.426 13.055-.068.139.068.055-21.174 43h97.304c0-63.95-25.012-97.084-62.067-111.976l-.086.157-30.403 55.57zM148.5 206.007c-4.319 0-8.57-.293-12.74-.85l6.817 12.327-5.42 79.516h22.686l-5.42-79.516 6.817-12.327c-4.17.557-8.421.85-12.74.85zM228.184 110.561c-5.781.802-15.017 1.926-26.017 2.943v11.993c0 11.737-9.762 21.253-21.5 21.253s-21.5-9.516-21.5-21.253v-9.616c-3 .074-7.172.119-11 .119-3.828 0-8-.045-11-.119v9.616c0 11.737-9.762 21.253-21.5 21.253s-21.5-9.516-21.5-21.253v-11.993a570.631 570.631 0 0 1-25.657-2.937c-.009-.001.065-.007.056-.007.166 43.903 35.993 79.44 79.934 79.44h.026c43.93 0 79.492-35.545 79.658-79.439zM70.294 94.61C82.852 96.355 113.296 100 148.5 100s65.648-3.645 78.206-5.39c-.008-.038-.014-.078-.021-.117 5.856-.862 11.137-1.82 15.742-2.858C255.39 88.713 263 85.157 263 81.322c0-4.506-10.499-8.627-27.855-11.787-2.73-.497-5.635-.97-8.69-1.418a76.113 76.113 0 0 0-2.157-16.293C216.959 21.977 192.012 0 161.935 0h-26.869c-30.677 0-56.743 22.863-63.719 53.621a74.102 74.102 0 0 0-1.804 14.644c-2.691.403-5.257.827-7.688 1.271C44.499 72.695 34 76.816 34 81.322c0 3.835 7.61 7.391 20.573 10.313 4.605 1.038 9.886 1.996 15.742 2.858-.007.039-.013.079-.021.117z" fill="#000000" opacity="1" data-original="#000000"></path></svg>
                    </div>
                    <span className="altcor-ai-feature-text">Автоматическая классификация различных типов данных</span>
                  </div>
                  <div className="altcor-ai-feature">
                    <div className="altcor-ai-feature-icon">
                      <i className="fas fa-shield-alt"></i>
                    </div>
                    <span className="altcor-ai-feature-text">Соответствие требованиям законодательства о защите данных</span>
                  </div>
                </div>
                
                <div className="altcor-ai-stats">
                  <div className="altcor-ai-stat">
                    <div className="altcor-ai-stat-value">98%</div>
                    <div className="altcor-ai-stat-label">Точность</div>
                  </div>
                  <div className="altcor-ai-stat">
                    <div className="altcor-ai-stat-value">0.1с</div>
                    <div className="altcor-ai-stat-label">Скорость анализа</div>
                  </div>
                 
                </div>
                
                <div className="altcor-ai-actions">
                  <button 
                    className="altcor-ai-button primary"
                    onClick={handleOpenPopup}
                  >
                    <i className="fas fa-rocket"></i>
                    Попробовать
                  </button>
                  
                </div>
              </div>
              
              <div className="altcor-ai-visual">
                <div className="altcor-ai-visual-container">
                  <div className="altcor-ai-scan-effect">
                    <div className="altcor-ai-scan-line"></div>
                    <div className="altcor-ai-floating-element">Диплом</div>
                    <div className="altcor-ai-floating-element">Паспорт</div>
                    <div className="altcor-ai-floating-element">Загранпаспорт</div>
                    <div className="altcor-ai-floating-element">Водительские права</div>
                    <div className="altcor-ai-data-point"></div>
                    <div className="altcor-ai-data-point"></div>
                    <div className="altcor-ai-data-point"></div>
                  </div>
                  <div className="altcor-ai-visual-content">
                    <div className="altcor-ai-visual-image"></div>
                    <div className="altcor-ai-visual-text">Анализ документа...</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Добавляем попап */}
      <ApplicationPopup 
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        type="алькор-ai"
        title="Попробовать ALTCOR AI"
      />
    </section>
  );
};

export default AltcorAI;